import React from "react";
import Modal from "react-modal";
import { useDispatch } from "react-redux";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import withReduxProvider from "web/react/redux-provider";
import { closeCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import { RawBranchLink } from "web/script/utils/branch-io";
import BranchLink from "web/react/components/branch-link/branch-link";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./app-acquisition-overlay.css";

interface AppAcquisitionOverlayProps {
    captureType: "signup_feed_save" | "signup_du"; // Move these to constants
}

export function AppAcquisitionOverlay({
    captureType,
}: AppAcquisitionOverlayProps): null | JSX.Element {
    const dispatch = useDispatch();
    // Depending on the captureType ...
    let messagingCopy;
    let branchLink;

    switch (captureType) {
        case "signup_du":
            // "Download the App for free to follow new products and deals from this designer."
            messagingCopy = gettext("designer_updates.overlay.app_download");
            branchLink = RawBranchLink.DesignerUpdates;
            break;
        case "signup_feed_save":
        default:
            // "Download the App for free and we’ll let you know as soon as this goes on sale."
            messagingCopy = gettext("save_for_later.overlay.app_download");
            branchLink = RawBranchLink.SaveForLater;
            break;
    }

    function triggerClose(): void {
        analytics.event(captureType, "close_app_acquisition_form");
        dispatch(closeCustomerCaptureOverlay());
    }

    function triggerAfterOpen(): void {
        analytics.event(captureType, "open_app_acquisition_form", undefined, true); // non interactive
    }

    let appElement: HTMLElement | undefined;
    if (document.body) {
        appElement = document.body.querySelector<HTMLDivElement>(".site-wrapper") || undefined;
    }

    return (
        <Modal
            appElement={appElement}
            className={styles.modal}
            isOpen={true}
            onAfterOpen={triggerAfterOpen}
            onRequestClose={triggerClose}
            overlayClassName={styles.overlay}
        >
            <div className={styles.content}>
                <div className={styles.brandImage}>
                    <CloseButton className={styles.closeButton} onClick={triggerClose} />
                </div>
                <div className={styles.logoHolder}>
                    <div className={styles.logo} />
                </div>
                <div className={styles.messaging}>
                    <h4 dangerouslySetInnerHTML={{ __html: messagingCopy }}></h4>
                    <BranchLink
                        // "Download on the App Store"
                        title={gettext("general.mobile.image_alt_text")}
                        className={styles.appStoreBadge}
                        branchLink={branchLink}
                        eventCategory={captureType}
                        eventAction={"click_signup_button"}
                        eventLabel={"signup_button"}
                    />
                </div>
            </div>
        </Modal>
    );
}

export default withReduxProvider(AppAcquisitionOverlay);
